import { handleActions } from 'redux-actions';
import LinkedStatementListModel from 'models/api/linked-statement-list-model';

import {
  setLinkedStatementsError,
  setLinkedStatementsLoaded,
  setLinkedStatementsLoading,
  clearLinkedStatements,
  removeLinkedStatementOnUnlink,
  updateLinkedStmtListStatus,
} from 'store/actions/linked-statement-list-actions';

export default handleActions(
  {
    [setLinkedStatementsLoading]: (linkedStatement, { payload }) => {
      return linkedStatement.setLoading();
    },
    [setLinkedStatementsLoaded]: (linkedStatement, { payload }) => {
      return linkedStatement.setLoaded(payload);
    },
    [setLinkedStatementsError]: (linkedStatement, { payload }) => {
      return linkedStatement.setError(payload);
    },
    [removeLinkedStatementOnUnlink]: (linkedStatement, { payload }) => {
      linkedStatement.removeStatementFromList(
        payload.clientId,
        payload.statementId,
        payload.revisionId,
      );
      return linkedStatement;
    },
    [updateLinkedStmtListStatus]: (linkedStatement, { payload }) => {
      linkedStatement.updateStatusByClientStatementRevision(payload);
      return linkedStatement;
    },
    [clearLinkedStatements]: () => {
      return new LinkedStatementListModel();
    },
  },
  new LinkedStatementListModel(),
);
